export default "__VITE_ASSET__COXb_bQT__"